var map = {
	"./Bagging.png": "c6c5",
	"./Created.png": "4ba8",
	"./Delivered.png": "cd13",
	"./InTransit.png": "3c72",
	"./Malaysia.png": "7ab1",
	"./Outscan.png": "d667",
	"./Printed.png": "2a37",
	"./QRCode.png": "7a44",
	"./Signed.png": "d7ce",
	"./Singapore.png": "1fb9",
	"./Taiwan.png": "54d9",
	"./aupost.png": "4f6b",
	"./ems.png": "defb",
	"./noRecord.png": "e371",
	"./testimonial-image-01.png": "f814",
	"./testimonial-image-02.png": "c318",
	"./testimonial-image-03.png": "bb12",
	"./wechat.png": "37c4",
	"./whatsapp.png": "d253",
	"./xmt.png": "dfb6"
};


function webpackContext(req) {
	var id = webpackContextResolve(req);
	return __webpack_require__(id);
}
function webpackContextResolve(req) {
	if(!__webpack_require__.o(map, req)) {
		var e = new Error("Cannot find module '" + req + "'");
		e.code = 'MODULE_NOT_FOUND';
		throw e;
	}
	return map[req];
}
webpackContext.keys = function webpackContextKeys() {
	return Object.keys(map);
};
webpackContext.resolve = webpackContextResolve;
module.exports = webpackContext;
webpackContext.id = "e078";